import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { bridge } from './lib/bridge-client';
import './styles.css';

// Render immediately with a loading state, then update when bridge is ready
const root = ReactDOM.createRoot(document.getElementById('root')!);

// Show loading immediately
root.render(
  <React.StrictMode>
    <div style={{ padding: 20, textAlign: 'center' }}>
      <p>Waiting for bridge connection...</p>
    </div>
  </React.StrictMode>
);

// Wait for bridge to be ready before rendering full app
bridge.onReady(() => {
  console.log('[Pinpoint] Bridge ready, rendering app');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// Set a timeout to show an error if bridge doesn't connect
setTimeout(() => {
  if (!bridge.isReady()) {
    console.error('[Pinpoint] Bridge connection timeout');
    root.render(
      <React.StrictMode>
        <div style={{ padding: 20, textAlign: 'center', color: '#dc2626' }}>
          <p>Bridge connection failed.</p>
          <p style={{ fontSize: 12, color: '#666', marginTop: 8 }}>
            Check the console for errors.
          </p>
        </div>
      </React.StrictMode>
    );
  }
}, 10000);
